import { matchIntelPage } from '@/services/to-intel.service'
import { ElMessage } from 'element-plus'
import { HIDE_FUNC } from '@/common/const/hide-function-config'
import { IS_JP_ONLY_BUILD } from '@/common/const/build-locale'
import { copyText } from '@/utils/tool'

export function intelLink (el: HTMLElement, binding: any) {
  const params = binding.value
  let isBlank
  let path
  if (typeof params === 'string') {
    isBlank = false
    path = params
  } else {
    isBlank = params.isBlank || false
    path = params.path
  }

  el.innerText = path

  // 日文专版：不跳转威胁情报、不高亮为链接，仅点击复制
  if (IS_JP_ONLY_BUILD) {
    el.classList.remove('cm-link-light')
    el.style.cursor = path ? 'pointer' : ''
    el.onclick = path
      ? (e) => {
          e.stopPropagation()
          copyText(String(path))
        }
      : () => {}
    return
  }

  if (!path?.includes('*') && !HIDE_FUNC.threatIntel) {
    el.classList.add('cm-link-light')
    el.onclick = (e) => {
      e.stopPropagation()
      matchIntelPage(path, isBlank).catch(() => {
        ElMessage.error('未知IOC类型，跳转失败')
      })
    }
  } else {
    el.classList.remove('cm-link-light')
    el.onclick = () => ({})
  }
}
